import Debug from '../../helpers/debug.js';
import ora from 'ora';
import axios from 'axios';
import Table from 'cli-table';
import descriptions from '../../helpers/descriptions.js';
import { pp, pr, printJSON, themed } from '../../helpers/print.js';

const debug = Debug('commands:tenants:list');

const command = 'list';

const desc = 'List tenants';

const builder = async (yargs) => {
  debug('builder', command);

  return yargs.option('tenant', descriptions.options['tenant'].config);
};

const handler = async (argv) => {
  debug('handler', command, argv);

  const { hg, json, apikey, env, tenant } = argv;

  let message;
  let spinner = ora();
  try {
    // 1. get data from client-api backend
    message = themed(`Retrieving tenants for environment ${themed(env, 'info')}`);
    const uri = `${hg.clientApiBaseUri}/tenants/${env}${tenant ? `?tenant=${tenant}` : ''}`;
    debug('requesting:', uri);
    !json && spinner.start(themed(`In progress: ${message}...`, 'secondary'));
    const { data } = await axios.get(uri, { headers: { 'x-api-key': apikey } });
    !json && spinner.succeed(themed(`Finished: ${message}.`, 'secondary'));
    debug('response-data', data);

    // exit if there is no data
    if (!data || data.length === 0) {
      json
        ? printJSON([])
        : spinner.info(themed(`Info: ${themed('No tenants found in the specified environment')}.`, 'secondary'));
      return;
    }

    if (json) {
      printJSON(data);
    } else {
      // generate results table
      const table = new Table({ head: ['tenant ID'] });
      table.push(...data.map((item) => [item]));

      // print results
      console.log(table.toString());
    }
  } catch (err) {
    if (json) {
      printJSON({ status: 'error', error: err });
    } else {
      spinner.fail(themed(`Error: ${message}.`, 'secondary'));
      pr(themed(`Message: ${themed(err.message)}`, 'secondary'));
      debug(err);
      if (err && err.response && err.response.data) {
        debug('response', err.response.data);
      }
    }
  }
};

export { command, desc, builder, handler };
